// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__VfTo3","borderVar":"Variant_borderVar__bZAB4","varNumber":"Variant_varNumber__WUZCy","varTitle":"Variant_varTitle__IUALW"};